var _path, _path2, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadmore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0466 9.16503C16.7542 8.87093 16.2677 8.87093 15.9651 9.16503C15.6728 9.4492 15.6728 9.92215 15.9651 10.2057L21.4488 15.5359H9.70144C9.27962 15.5366 8.94434 15.8625 8.94434 16.2725C8.94434 16.6825 9.27962 17.019 9.70144 17.019H21.4488L15.9651 22.3393C15.6728 22.6334 15.6728 23.107 15.9651 23.3905C16.2677 23.6846 16.7549 23.6846 17.0466 23.3905L23.8285 16.7984C24.1311 16.5143 24.1311 16.0413 23.8285 15.7578L17.0466 9.16503Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2089_140",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0466 9.16503C16.7542 8.87093 16.2677 8.87093 15.9651 9.16503C15.6728 9.4492 15.6728 9.92215 15.9651 10.2057L21.4488 15.5359H9.70144C9.27962 15.5366 8.94434 15.8625 8.94434 16.2725C8.94434 16.6825 9.27962 17.019 9.70144 17.019H21.4488L15.9651 22.3393C15.6728 22.6334 15.6728 23.107 15.9651 23.3905C16.2677 23.6846 16.7549 23.6846 17.0466 23.3905L23.8285 16.7984C24.1311 16.5143 24.1311 16.0413 23.8285 15.7578L17.0466 9.16503Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2089_140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8.5H30.2778V30.2778H8.5V8.5Z",
    fill: "#246DF1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#246DF1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadmore);
export default __webpack_public_path__ + "static/media/readmore.2707311650b30d1e6a27329c8ffd477c.svg";
export { ForwardRef as ReactComponent };